import apisauce from "apisauce";

const create = () => {
	// const baseURL = "http://purewaterjb.aglobalcloud.com/PW2";
	// const baseURL = "http://purewaterjb.aglobalcloud.com/PWPreLive";
	const baseURL = "https://trace.purewaterjb.com/pw";
	const api = apisauce.create({
		baseURL: baseURL,
		headers: {
			"Content-Type": "application/json",
		},
		timeout: 10000,
	});

	const checkSerial = (SerialNo) => api.post("/TracibilityApi/CheckQCResult", { SerialNo });

	return {
		checkSerial,
	};
};

export default {
	create,
};
